import React from 'react';
import sprocketsImg from "../../assets/sprockets.png";

const PlanWizardWelcomeStep = ({skip, handleNextStep}) => {

    if (skip) {
        handleNextStep();
        return <></>
    }

    return (
        <div class={"plan-wizard-welcome-step"}>
            <p>
                Plan Automation Wizard helps you to fill out the Future Adjustments section of the plan,
                based on a few simple questions you would provide with regards to the plan preference.
                After the Future Adjustments are filled out by the wizard, you would still be able change
                the entries based on your need.
            </p>
            <p>
                If needed, you can always run the wizard again to achieve the desired plan output.
                Simply be aware that re-running the wizard would overwrite any previous Future Adjustment entries.
            </p>
            <p>
                <img className={"plan-automation-sprockets"} title={"Interlocking Gears"} alt={"Interlocking Gears"} src={sprocketsImg} />
            </p>
        </div>
    );
};

export default PlanWizardWelcomeStep;
